import { Switch } from "@mui/material";
import { AtSwitchProps } from "./at-switch.types";
import { GlobalSwitchStyles } from "../../../theme/global-styles";
import { AtTag, AtTagAccountsStatus, AtTagType } from "../at-tag";

export const AtSwitch = ({
  checked = false,
  disabled = false,
  required = false,
  showTag = false,
  label,
  onChange,
  "data-testid": testId,
}: AtSwitchProps) => {
  return (
    <div className="flex items-center text-sm font-semibold">
      <GlobalSwitchStyles />
      {label}
      <Switch
        data-testid={testId}
        checked={checked}
        disabled={disabled}
        required={required}
        onChange={onChange}
      />
      {showTag && (
        <AtTag
          type={AtTagType.ACCOUNTS}
          status={
            checked ? AtTagAccountsStatus.ACTIVE : AtTagAccountsStatus.INACTIVE
          }
        />
      )}
    </div>
  );
};
